/**
 * @description 创建一个script
 * @param {String} url
 * @return {Promise} _promise
 */

function createScript(url, hasCallback) {
  // 创建一个script标签元素
  let scriptElement = document.createElement("script");
  // 将script标签元素加入body中
  document.body.appendChild(scriptElement);
  let _promise = new Promise((resolve, reject) => {
    scriptElement.addEventListener(
      "load",
      e => {
        removeScript(scriptElement);
        if (!hasCallback) {
          resolve(e);
        }
      },
      false
    );

    scriptElement.addEventListener(
      "error",
      e => {
        removeScript(scriptElement);
        reject(e);
      },
      false
    );

    if (hasCallback) {
      window.__callback__ = function() {
        resolve();
        window.__callback__ = null;
      };
    }
  });

  if (hasCallback) {
    url += "&callback=__callback__";
  }

  scriptElement.src = url;

  return _promise;
}

/**
 * @description 移除script标签
 * @param scriptElemnet script dom
 */

function removeScript(scriptElement) {
  document.body.removeChild(scriptElement);
}

export default function remoteLoad(url, hasCallback) {
  return createScript(url, hasCallback);
}
